import type { ReportConversionFunction } from '../types';

/**
 * Fires conversion pixel for Rate Market Place referrals.
 */
export const reportRateMarketPlaceConversion: ReportConversionFunction = () => {
  const ifrm = window.document.createElement('iframe');
  ifrm.setAttribute('src', '//finance.mediaalpha.com/p/G3hHNkOAUhnW86TnhP47Id86buDVdA?u=1');
  ifrm.style.width = '1';
  ifrm.style.height = '1';
  ifrm.frameBorder = '0';
  window.document.body.appendChild(ifrm);
};
